import {FormioBase} from "./formiobase";

export class CheckBox extends FormioBase {
  public inputType = "checkbox";
  public title = "Check Box";
  public icon = "fa fa-check-square";
  public schema: any = {
    title: "checkbox",
    components: [{
      input: true,
      inputType: "checkbox",
      tableView: true,
      label: "CheckBox",
      datagridLabel: true,
      key: undefined,
      defaultValue: false,
      protected: false,
      persistent: true,
      disabled: false,
      notvisible: false,
      validate: {
        required: false,
        requiredOneTrue: false,
      },
      type: "checkbox",
      tags: [],
      description: "",
      tooltip: "",
      customClass: "ds-checkbox",
    }],
  };
}
